/**
 * Administração da plataforma de IA — chaves de API por escritório.
 *
 * A chave em claro só trafega na gravação (PUT). Nenhuma resposta a devolve:
 * o backend expõe apenas a máscara (prefixo estrutural + 4 últimos).
 */
import { api } from './client';

export interface EscritorioIa {
  id: string;
  nome: string;
  total_membros: number;
  /** Máscara da chave (`sk-ant-api03…abcd`); `null` = usa a chave da plataforma. */
  chave_mascara: string | null;
  chave_atualizada_em: string | null;
  /** `false` quando há chave gravada que não decifra (exige recadastro). */
  chave_legivel: boolean;
  /** Gasto do mês corrente na chave do escritório, em centavos de BRL. */
  consumo_mes_centavos: number;
  /** Gasto do mês corrente dos membros, em qualquer chave (centavos de BRL). */
  consumo_membros_centavos: number;
}

/**
 * `comChave` limita aos escritórios que JÁ têm chave própria — é a lista da
 * tela. Sem ele, vêm todos, que é o que o seletor de vínculo precisa.
 */
export async function fetchEscritoriosIa(busca?: string, comChave = false): Promise<EscritorioIa[]> {
  const { data } = await api.get<EscritorioIa[]>('/admin/ia/escritorios', {
    params: { ...(busca ? { busca } : {}), ...(comChave ? { com_chave: true } : {}) },
  });
  return data;
}

export async function gravarChaveIa(escritorioId: string, apiKey: string): Promise<EscritorioIa> {
  const { data } = await api.put<EscritorioIa>(`/admin/ia/escritorios/${escritorioId}/chave`, {
    api_key: apiKey,
  });
  return data;
}

export async function removerChaveIa(escritorioId: string): Promise<void> {
  await api.delete(`/admin/ia/escritorios/${escritorioId}/chave`);
}

/** Custo x créditos de um mês, produto e nível (painel de margem). */
export interface MargemIa {
  mes: string; // YYYY-MM
  produto: string;
  nivel: string | null;
  acoes: number;
  creditos: number;
  /** Custo real do grupo no mês, em centavos de BRL. */
  custo_centavos: number;
  /** Quanto custa 1 crédito, em centavos (referência de lançamento: 10). `null` = não debita créditos. */
  custo_por_credito_centavos: number | null;
}

export async function fetchMargemIa(meses = 3): Promise<MargemIa[]> {
  const { data } = await api.get<MargemIa[]>('/admin/ia/margem', { params: { meses } });
  return data;
}
